// Version : 0.0.1
// Author : Vignesh
// LastEdit : Vignesh
// Last ADD : Payload Destructure
// MODFIED DATE : 01-09-2025

import { all, call, put, takeLatest } from 'redux-saga/effects';
import { encryptData } from '../../../_common/enode-decode';
import AlertManager from '../../../../utils/alertManager';
import {
	TrailBalanceFailure,
	TrailBalanceResponceChanged,
	TrailBalanceSuccess,
} from './trailBalance.action';
import TrailBalanceTypes from './trailBalance.types';
import { TrailBalanceGetBranch } from './trailBalance.service';

/******************GET PROFIT AND LOSS *********************/
export function* TrailBalanceDetails({ payload }: any) {
	try {
		const {
			asOnDate,
			fromDate,
			toDate,
			type,
			infog_CompanyID,
			companyID,
			viewUser,
			userAccessBranchID,
			filterHOTrxn,
			databaseName,
		} = payload;
		const key = 'TrailBalanceKey';
		const jsonData = {
			AsOnDate: asOnDate,
			FromDate: fromDate,
			ToDate: toDate,
			Type: type,
			Infog_CompanyID: infog_CompanyID,
			companyID: companyID,
			ViewUser: viewUser,
			UserAccessBranchID: userAccessBranchID,
			DatabaseName: databaseName,
			FilterHOTrxn: filterHOTrxn,
		};
		const encodeData = encryptData(jsonData, key);
		//@ts-ignore
		const responseData = yield call(TrailBalanceGetBranch, encodeData); // data received
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(TrailBalanceFailure(responseData.data));
		} else {
			yield put(TrailBalanceSuccess(responseData.data));
		}
	} catch (error) {
		yield put(TrailBalanceFailure(error));
	}
}
export function* resetTrailBalanceResponse() {
	yield put(TrailBalanceResponceChanged());
}

export function* onTrailBalanceDetails() {
	yield takeLatest(TrailBalanceTypes.GET_TRAIL_BALANCE_START, TrailBalanceDetails);
}

export function* onTrailBalanceResponseReset() {
	yield takeLatest(TrailBalanceTypes.GET_TRAIL_BALANCE_RESPONSE_RESET, resetTrailBalanceResponse);
}
/******************GET PROFIT AND LOSS *********************/
export function* TrailBalanceFinanceSaga() {
	yield all([call(onTrailBalanceDetails), call(onTrailBalanceResponseReset)]);
}
